import SelectManualUtilityPlanOptionsFlowStep from '../SelectManualUtilityPlanOptionsFlowStep'
import DefineManualPlanFlowStep from '../DefineManualPlanFlowStep'
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom'
import { useNavigation } from '@/app/hooks'

export interface Props {
  onComplete?: () => void
}

function SelectManualOptionStep() {
  const navigation = useNavigation()
  const onOptionSelect = () => {
    navigation.push('manual-plan')
  }

  return (
    <SelectManualUtilityPlanOptionsFlowStep onOptionSelect={onOptionSelect} />
  )
}

function DefineManualPlanStep(props: Props) {
  return <DefineManualPlanFlowStep onComplete={props.onComplete} />
}

/**
 * Manual rate-plan creation flow. The old "options" landing (upload bill /
 * select from a list / set manually) and the "select plan from a list" step were
 * removed once nothing routed to them — adding a plan now always goes straight
 * to manual rate entry. The base `/connect-utility/plan` path is preserved and
 * redirects into that flow.
 */
export default function AddUtilityPlanFlow(props: Props) {
  const { path } = useRouteMatch()

  return (
    <Switch>
      <Route
        exact
        path={`${path}/manual-select`}
        component={() => <SelectManualOptionStep />}
      />
      <Route
        exact
        path={`${path}/manual-plan`}
        component={() => <DefineManualPlanStep {...props} />}
      />
      <Route exact path={path}>
        <Redirect to={`${path}/manual-select`} />
      </Route>
    </Switch>
  )
}
